module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAoCAYAAACB4MgqAAABNElEQVR4nO2ZTWrDMBCF3xtk6CUKXdW9RpyEnNn5O0eaLnuHbpJouqgxslP648iDA/OBFgLz/GkYyyARAN4WC8TLBSChqhgKAbAo8LxeD87487te53NA9Sbhq9AQUG422fK+IyBG5FNuOJ9zJ14hSrYTksNHEqoAjsvlqOIBSYsogJf9flDQ+2qFj9OpbTkdueqSK+ixrtEvwpjwMJslM4K3fKTJrkTyl4f/h6oCJB6KAk913RO/B0iISL5WMUMVMcY7FG8I6YQy4XWkP0nVrriqDt4Ox+ZYVZ2dasIl/hkXt8bFrXFxa1zcGhe3xsWtcXFrXNwaF7fGxa1xcWvuVpyHqmqPh3OfsOakc9VDIlC1PSHKeQ80JgQgEJl0pfuQBEQg5W4HEfm66pvwAtgMEUG53eITavVcZ5VGCEYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/space.png
// module id = jGb+
// module chunks = 1